import { array, boolean, date, enumValues, nullable, object, string } from "../../../types/_types";

import articleDeliveryTypes from "../constants/articleDeliveryTypes";
import articlePublicationStatuses from "../constants/articlePublicationStatuses";

import { ArticleChannelDelivery } from "./ArticleChannelDelivery";
import { ArticlePrice } from "./ArticlePrice";

const articleDeliveryType = enumValues(articleDeliveryTypes);
export const articlePublicationStatus = enumValues(articlePublicationStatuses);

export const ArticleChannelMetaData = object({
	announcementDate: nullable(date()),
	releaseDate: nullable(date()),
	takedownDate: nullable(date()),
	countries: array(string()),
	prices: array(ArticlePrice),
	subChannels: array(object({ id: string(), name: string() })),
});

export const ArticleChannel = ArticleChannelMetaData.extend({
	delivery: ArticleChannelDelivery.partial().default({}),
	deliveryTypes: array(articleDeliveryType),
	publicationStatus: articlePublicationStatus.default(articlePublicationStatuses.NOT_PUBLISHED),
	preventTakedown: boolean(false),
});
